import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import DraftComplete    from '@draft/draft-submit-complete';

// -------------------------------------------------------


class DraftSubmit extends React.Component {
  submit() {
    let data = this.props.data;
    let detail = this.props.detail;
    
    Utils.request.bind(this)('/api/draft/revise', { draft_id: detail.id, project_id: data.project.id, edit: this.props.edit },
      function(res){
        this.props.change_ev.bind(this)(detail.id, 'submit');
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  cancel() {
    let data = this.props.data;
    let detail = this.props.detail;
    
    let chk = confirm('作成した内容を取り消してもよろしいですか？');
    if( chk == false ) return;
    
    this.props.change_ev.bind(this)(detail.id, 'cancel');
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let detail = this.props.detail;
    let edit = this.props.edit;
    
    // フロー制御
    if( this.props.edit_mode !== true ){
      if( detail.is_draft_action == false || detail.is_flow_action == false || detail.complete == 1 ){
        return null;
      }
    }
    
    return (
      <div className="draft-submit-box">
        { (Object.keys(edit).length > 0)
          ? <div className="action-multi">
              <div className="button" onClick={this.submit.bind(this)}>保存</div>
              <div className="button no" onClick={this.cancel.bind(this)}>取り消し</div>
            </div>
          : null/*<div className="action-multi">
              <div className="button off">保存</div>
              <div className="button no off">取り消し</div>
            </div>*/
        }
        
        <DraftComplete data={data} detail={detail} edit={edit} update_ev={this.props.update_ev.bind(this)} change_ev={this.props.change_ev.bind(this)} />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftSubmit;